import { Avatar } from "@/components/buttons/Avatar";
import UserOutlined from "@ant-design/icons/es/icons/UserOutlined";
import { Form, Input, theme } from "antd";
export const UsernameField = ({
  email,
  variant = "field"
}: {
  email?: string | null;
  variant?: "field" | "chip";
}) => {
  const {
    token
  } = theme.useToken();
  if (variant === "chip") {
    return <div className="mx-auto mb-4 flex w-max items-center gap-2 rounded-lg border border-gray-200 p-1 pr-2 text-center text-sm">
        <Avatar name={email || ""} size={20} />
        <span className="grid">
          <span aria-hidden className="invisible col-start-1 row-start-1 whitespace-pre">
            {email}
          </span>
          <input className="col-start-1 row-start-1 w-full cursor-default bg-transparent outline-none" value={email ?? ""} aria-label="Email" autoComplete="username" readOnly tabIndex={-1} />
        </span>
      </div>;
  }

  // Read-only so password managers still see the username; inline so it also beats hover and focus.
  const disabledLook = {
    color: token.colorTextDisabled,
    backgroundColor: token.colorBgContainerDisabled,
    borderColor: token.colorBorder,
    boxShadow: "none",
    cursor: "not-allowed"
  };
  return <Form.Item style={{
    margin: 0,
    marginBottom: "16px"
  }} data-sentry-element="unknown" data-sentry-component="UsernameField" data-sentry-source-file="UsernameField.tsx">
      <Input prefix={<UserOutlined />} value={email ?? ""} autoComplete="username" readOnly style={disabledLook} styles={{
      input: {
        ...disabledLook,
        backgroundColor: "transparent"
      }
    }} data-sentry-element="Input" data-sentry-source-file="UsernameField.tsx" />
    </Form.Item>;
};